import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=4b4e1e9a&scoped=true&transition=scale-transition&origin=center%20center&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=4b4e1e9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e1e9a",
  null
  
)

export default component.exports